import Repository from "../../Helpers/Repository";
import Variable from "../../Helpers/Variable";
import {DOMException} from "../../../../../../../../wp-core/wp-includes/js/dist/vendor/wp-polyfill-fetch";
import Language from "../../Helpers/Language";

export default class GroupedStages {
    constructor() {
        this.official_stage_id = null;
        this.parallel_stage_id = null;
        this.stages = [];
        this.official_stages = [];
        this.parallel_stages = [];
    }

    async build() {
        return await new Repository().getStages().then(async (response) => {
            if (Variable.empty(response.data)) {
                return this;
            }

            const officialStageSlug = Language.isPortuguese() ? 'oficial' : 'official';
            const parallelStageSlug = Language.isPortuguese() ? 'paralelo' : 'parallel';

            response.data.forEach((stage) => {
                if (stage['slug'] === officialStageSlug) {
                    this.official_stage_id = stage['id'];
                }

                if (stage['slug'] === parallelStageSlug) {
                    this.parallel_stage_id = stage['id'];
                }
            });

            if (Variable.empty(this.official_stage_id) && Variable.empty(this.parallel_stage_id)) {
                return this;
            }

            this.stages = response.data;

            this.stages.forEach((stage) => {
                if (stage['parent'] === this.official_stage_id) {
                    this.official_stages.push(stage);
                } else if (stage['parent'] === this.parallel_stage_id) {
                    this.parallel_stages.push(stage);
                }
            });

            return this;
        });
    }

    getOfficialStageId() {
        return this.official_stage_id;
    }

    getParallelStageId() {
        return this.parallel_stage_id;
    }

    getAllStages() {
        return this.stages;
    }

    getOfficialStages() {
        return this.official_stages;
    }

    getParallelStages() {
        return this.parallel_stages;
    }
}
